import { AxiosError } from "axios";
import { apiUrls } from "consts";
import { axiosPost } from "shared/api/axios";
import displayGenError from "shared/utils/displayGenError";

interface createPermissionOnBackgroundProps{
    setShowOverlay: Function,
    navigate: Function,
}

const createPermissionOnBackground = async (props: createPermissionOnBackgroundProps) => {
    props.setShowOverlay(true)
    const catchFunc = (err: AxiosError) => {
        displayGenError({ setShowOverlay: props.setShowOverlay })
    }

    const response = await axiosPost(apiUrls.permissions + '/' + apiUrls.actionCreateOnBackground , {}, catchFunc);

    if (response?.status === 201) {
        const permissionId = response.data.id;
        props.navigate('/edit-permission/' + permissionId + '?temp=1')
    }

}

export default createPermissionOnBackground